import { IconFont, SvgIcon } from '@/components'
import { Form, Input, message, Radio, Upload } from 'antd'
import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { usePutAttachmentName } from './utils'
import { Message } from '@/components/message'
import { t } from '@/i18n'
export const EditAccessory = props => {
  const { particulars, submit, id, acquire } = props
  console.log('particulars', particulars)
  const [isEditGroupName, setIsEditGroupName] = useState(false)
  const [putAttachmentName] = usePutAttachmentName()
  const [fileName, setFileName] = useState('')
  const inputContentRef = useRef('')
  const [suffix, setSuffix] = useState()
  const [isReplace, setIsReplace] = useState(0)
  // const [fileList, setFileList] = useState([])
  // const [uploadedFile, setUploadedFile] = useState(null)
  useEffect(() => {
    if (submit.accomplish) {
      // const formData = new FormData()
      // if (uploadedFile) {
      //   formData.append('file', uploadedFile)
      // }
      // formData.append('is_replace', isReplace === 0 ? 'false' : 'true')
      // formData.append(
      //   'attachment_name',
      //   fileName ||
      //     particulars.attachment_name.substring(0, particulars.attachment_name.lastIndexOf('.')),
      // )
      // formData.append('old_attachment_name', particulars.attachment_name)

      putAttachmentName({
        id: particulars.id,
        // formData,
        is_replace: isReplace === 0 ? false : true,
        attachment_name:
          fileName ||
          particulars.attachment_name.substring(0, particulars.attachment_name.lastIndexOf('.')),
        old_attachment_name: particulars.attachment_name,
      })
        .then(res => {
          acquire()
        })
        .catch(_ => {})
    }
  }, [submit])
  useEffect(() => {
    if (particulars?.attachment_name) {
      setSuffix(particulars.attachment_name.substring(particulars.attachment_name.lastIndexOf('.')))
      setIsReplace(particulars?.is_replace ? 1 : 0 || 0)
    }
  }, [particulars])
  return (
    <EditTemplate>
      <div className="flex">
        <div>{t('附件：')}</div>
        <div className="attachment">
          {isEditGroupName ? (
            <div className="flex">
              <Input
                placeholder="请输入"
                defaultValue={
                  fileName !== ''
                    ? fileName
                    : particulars.attachment_name.substring(
                        0,
                        particulars.attachment_name.lastIndexOf('.'),
                      )
                }
                onChange={e => {
                  inputContentRef.current = e.target.value
                }}
              />

              <CloseCircleOutlined
                style={{ marginLeft: 12 }}
                onClick={() => {
                  setIsEditGroupName(false)
                }}
              />

              <CheckCircleOutlined
                style={{ marginLeft: 12 }}
                onClick={() => {
                  if (inputContentRef.current.length > 50) {
                    Message.error('附件名称最多50字')
                    return
                  }
                  setFileName(inputContentRef.current)
                  setIsEditGroupName(false)
                }}
              />
            </div>
          ) : (
            <div className="flex">
              {/* <Upload
               showUploadList={false}
               beforeUpload={file => {
                 const reg = /\.exe|\.pdf|\.docx|\.doc|\.xlsx|\.xls|\.rtf|\.pptx|\.ppt$/
                 if (!reg.test(file.name)) {
                   Message.error('附件格式有误')
                   return Upload.LIST_IGNORE
                 }
                 if (file.size / 1024 / 1024 > 10) {
                   Message.error('附件大小不能超过10M')
                   return Upload.LIST_IGNORE
                 }
                 setFileName(file.name.substring(0, file.name.lastIndexOf('.')))
                 setSuffix(file.name.substring(file.name.lastIndexOf('.')))
                 setUploadedFile(file)
                 return false
               }}
              >
               <IconFont type="icon-shangchuan2" style={{ marginRight: 8, cursor: 'pointer' }} />
              </Upload> */}
              {suffix === '.exe' ? (
                <Svg name={'mini_exe'} />
              ) : suffix === '.pdf' ? (
                <Svg name="mini_pdf" />
              ) : suffix === '.docx' || suffix === '.doc' ? (
                <Svg name="mini_docx" />
              ) : suffix === '.xls' || suffix === '.xlsx' ? (
                <Svg name="mini_xlsx" />
              ) : suffix === '.rtf' ? (
                <Svg name="mini_rtf" />
              ) : suffix === '.pptx' || suffix === '.ppt' ? (
                <Svg name="mini_ppt" />
              ) : (
                ''
              )}
              <span style={{ margin: '0 12px 0 12px', display: 'inline-block' }}>
                {fileName !== ''
                  ? fileName
                  : particulars.attachment_name.substring(
                      0,
                      particulars.attachment_name.lastIndexOf('.'),
                    )}
              </span>
              <Icon
                type="icon-huabanfuben"
                onClick={() => {
                  setIsEditGroupName(true)
                }}
              />
            </div>
          )}
        </div>
      </div>
      <div className="flex" style={{ marginTop: 24, marginBottom: 24 }}>
        <div>{t('附件记录：')}</div>
        <Radio.Group value={isReplace} onChange={e => setIsReplace(e.target.value)}>
          <Radio value={0}>{t('关闭')}</Radio>
          <Radio value={1}>{t('开启')}</Radio>
        </Radio.Group>
      </div>
      <div style={{ color: '#999', fontSize: 12 }}>
        {t('1.默认关闭，关闭时，用户可上传附件实现邮件发送，但无法实现附件打开行为记录')}
      </div>
      <div style={{ color: '#999', fontSize: 12 }}>
        {t('2.开启时，需要使用特制附件才可实现附件记录，特制附件模版及使用请联系平台提供方支持')}
      </div>
      <div style={{ color: '#999', fontSize: 12 }}>
        {t('3.开启后，平台会对上传附件中指定内容进行替换，替换后即可实现附件打开行为记录')}
      </div>
    </EditTemplate>
  )
}
const EditTemplate = styled.div`
  .flex {
    display: flex;
    align-items: center;
  }
  .attachment {
    width: 280px;
  }
`
const Icon = styled(IconFont)`
  cursor: pointer;
  color: #cccccc;
`
const Svg = styled(SvgIcon)`
  width: 16px;
  height: 16px;
`
